module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4n8n7r-fa64f9b49afc747061fa34660dfcb469.svg";